import { useState, useEffect, useMemo } from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useConfig } from "../../context/ConfigProvider";
import PayNowPopup from "./PayNowPopup";
import { IPaymentData } from "../../typings/interfaces/Payment/PaymentData";
import { submitPaymentIntent } from "../../api/apimethods";
import Loader from "../../components/molecules/Loader";
interface PaymentPageProps {
  paymentIntent: IPaymentData;
}

// stripePromise moved inside component so it can read runtime config

export default function PaymentPage({ paymentIntent }: PaymentPageProps) {
  const cfg = useConfig();
  const stripePromise = useMemo(() => loadStripe(cfg.REACT_APP_STRIPE_PUBLIC_KEY || ""), [cfg.REACT_APP_STRIPE_PUBLIC_KEY]);
  const [clientSecret, setClientSecret] = useState<string>("");

  useEffect(() => {
    async function createIntent() {
      try {
        const response = await submitPaymentIntent(paymentIntent); // correct

        if (response.data?.error) {
          throw new Error(response.data.error);
        }

        if (!response.data?.clientSecret) {
          throw new Error("Missing clientSecret from backend");
        }

        setClientSecret(response.data.clientSecret);
        paymentIntent.clientSecret = response?.data?.clientSecret;
        paymentIntent.paymentIntentId = response?.data?.paymentIntentId;
      } catch (error) {
        console.error("Payment Intent Error:", error);
      }
    }

    createIntent();
  }, [paymentIntent]);

  // Show Loader
  if (!clientSecret) {
    return (
      <Loader />
    );
  }

  return (
    <div className="mb-3">
      <Elements stripe={stripePromise} options={{ clientSecret }}>
        <PayNowPopup paymentIntentData = {paymentIntent} />
      </Elements>
    </div>
  );
}
